import { prefersReducedMotion } from '@theme/utilities';

class WlBenefitItem extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    if (prefersReducedMotion()) {
      this.classList.add('is-visible');
      return;
    }

    this.classList.add('is-reveal-enabled');

    requestAnimationFrame(() => {
      this.#observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry?.isIntersecting) return;

          requestAnimationFrame(() => {
            this.classList.add('is-visible');
          });
          this.#observer?.disconnect();
        },
        {
          threshold: 0.45,
          rootMargin: '0px 0px -18% 0px',
        }
      );

      this.#observer.observe(this);
    });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('wl-benefit-item')) {
  customElements.define('wl-benefit-item', WlBenefitItem);
}
